/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-sparse-arrays */
import React from "react"
import clsx from "clsx"
import { isMobileOnly } from "react-device-detect"
import { Trans, useTranslation } from "react-i18next"

import * as BikeApi from "features/bike/api/BikeApi"

import { useModal, useAlert, useBikeStoreProcess } from "hooks"
import { Markdown } from "components/Elements/Markdown"

import { BACK_PROPERTY_TRANSFER_REQUEST, bikeAccountTypes, BIKE_IN_SALE } from "utils/constants"
import { RequestModal } from "../Partials"
import { ErrorResponse } from "models"

export const BackToStoreCard: React.FC = () => {
	const { fetchBike, bikeProcessState } = useBikeStoreProcess()
	const { currentBike: bike } = bikeProcessState
	const { t } = useTranslation()
	const { showModal } = useModal()
	const { alert } = useAlert()
	const accountType = bikeAccountTypes.find(
		({ suffix }) => bike?.account_type === `${bike?.operator}${suffix}`
	)
	const isWalletNotMigratedAccountType =
		accountType?.id === "wallet_not_migrated" || accountType?.id === "nowallet_not_migrated"
	const translate_back_request = t("back_in_store.description_back_request", { ns: "bike" })
	const isBikeOnSale = bike?.status === BIKE_IN_SALE

	const handleSubmit = () => {
		showModal(RequestModal, {
			propertyTransferRequestContext: BACK_PROPERTY_TRANSFER_REQUEST,
			callbackAndSend: async () => {
				try {
					const bikePropertyTransferRequest = {
						context: BACK_PROPERTY_TRANSFER_REQUEST,
					}

					const updatedBikePayload = {
						bike_id: bike.code,
						row_version: bike.row_version,
						property_transfer_request: bikePropertyTransferRequest,
					}

					const { getError } = await BikeApi.editBike(updatedBikePayload)
					if (getError()) throw getError()

					alert("success", t("back_in_store.modal_success_message", { ns: "bike" }))
					fetchBike(bike.code)
				} catch (error) {
					console.error(error)
					const erroMsg = (error as ErrorResponse)?.message?.toString()
					if (erroMsg) alert("error", erroMsg)
				}
			},
		})
	}

	return (
		<div
			className={clsx("c-card p-5 md:p-12 mr-5", { "w-full": !isMobileOnly })}
			hidden={isBikeOnSale}
		>
			<h2 className="c-h2 font-semibold mb-5 uppercase">
				{t("back_in_store.title", { ns: "bike" })}
			</h2>

			{isWalletNotMigratedAccountType && (
				<div className="mt-1 mb-5">
					<Trans
						i18nKey={"back_and_buy.additional_description_back"}
						ns="bike"
						components={[
							,
							<a
								href="https://moncompte.bicycode.eu/se-connecter"
								rel="noreferrer"
								target="_blank"
								style={{ textDecoration: "underline" }}
							></a>,
						]}
					/>
				</div>
			)}

			<Markdown>
				{t("back_and_buy.description_with_account", {
					propertyTransferType: translate_back_request.toLowerCase(),
					ns: "bike",
				})}
			</Markdown>

			{!isWalletNotMigratedAccountType && (
				<div className="mt-5">
					<Trans
						i18nKey={"back_in_store.additional_description"}
						ns="bike"
						components={[<br />]}
					/>
				</div>
			)}

			{!isWalletNotMigratedAccountType && (
				<button
					type="button"
					data-cy="handle-back-bike"
					className="c-btn c-btn--primary c-btn--m px-7 mt-5"
					onClick={handleSubmit}
				>
					{t("back_in_store.button", { ns: "bike" })}
				</button>
			)}
		</div>
	)
}
